<template>
  <button
    ref="boton"
    :disabled="estado != EstadoPromesa.parada"
    @click="click()"
    id="boton-guardar"
    type="button"
    :class="'btn btn-success ' + ClaseEstado"
  >
    <span v-if="estado == EstadoPromesa.parada"
      >Guardar
      <font-awesome-icon :icon="Icons.GUARDAR" class="icono-derecha" />
    </span>
    <div v-else class="icono-estado">
      <div v-if="estado == EstadoPromesa.trabajando">
        <div class="icono spinner-border icono-derecha" role="status"></div>
      </div>
      <div v-else-if="estado == EstadoPromesa.exito">
        <font-awesome-icon :icon="Icons.EXITO" class="icono" />
      </div>
      <div v-else-if="estado == EstadoPromesa.error">
        <font-awesome-icon :icon="Icons.ERROR" class="icono" />
      </div>
    </div>
  </button>
</template>
<script>
import anime from "animejs/lib/anime.es.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { EstadoPromesa } from "../../data/enums";
import { Icons as IconConstants } from "../../constants";

/** Tiempo que duran las animaciones de feedback en milisegundos*/
const TIEMPO_FEEDBACK_DATOS_FALTANTES = 550;
const TIEMPO_FEEDBACK_EXITO = 2000;
const TIEMPO_FEEDBACK_ERROR = 2000;

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      estado: EstadoPromesa.parada,
      shakeAnimation: null,
    };
  },
  computed: {
    ClaseEstado() {
      if (this.estado == EstadoPromesa.parada) return "";
      else if (this.estado == EstadoPromesa.trabajando) return "trabajando";
      else if (this.estado == EstadoPromesa.exito) return "exito";
      else return "error";
    },
    EstadoPromesa() {
      return EstadoPromesa;
    },
    Icons() {
      return IconConstants;
    },
  },
  methods: {
    click() {
      this.estado = EstadoPromesa.trabajando;
      this.$emit("click");
    },
    feedbackDatosFaltantes() {
      this.shakeAnimation.play();
      this.limpiar();
    },
    feedbackExito() {
      this.estado = EstadoPromesa.exito;
      setTimeout(this.limpiar, TIEMPO_FEEDBACK_EXITO);
    },
    feedbackError() {
      this.estado = EstadoPromesa.error;
      setTimeout(this.limpiar, TIEMPO_FEEDBACK_ERROR);
    },
    limpiar() {
      this.estado = EstadoPromesa.parada;
    },
  },
  mounted() {
    const xMax = 16;
    this.shakeAnimation = anime({
      targets: "#boton-guardar",
      easing: "easeInOutSine",
      duration: TIEMPO_FEEDBACK_DATOS_FALTANTES,
      translateX: [
        {
          value: xMax * -1,
        },
        {
          value: xMax,
        },
        {
          value: xMax / -2,
        },
        {
          value: xMax / 2,
        },
        {
          value: 0,
        },
      ],
      autoplay: false,
    });
  },
};
</script>
<style scoped>
.icono-estado {
  margin-left: 2em;
  margin-right: 2em;
}
.icono {
  width: 16px;
  height: 16px;
}
.exito:disabled {
  opacity: 1;
}
.error {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}
.error:disabled {
  opacity: 1;
}
</style>